export default __webpack_public_path__ + "static/media/elise.0f6fa4c3.jpg";